import React, { FunctionComponent } from 'react';

import { Button } from 'react-bootstrap';

import 'core/pager/Pager.scss';

export interface PagerProps {
    canNext: boolean;
    canPrevious: boolean;
    onNext: () => void;
    onPrevious: () => void;
    label?: string;
    disabled?: boolean;
}

export const Pager: FunctionComponent<PagerProps> = ({ canNext, canPrevious, onNext, onPrevious, label, disabled }) => {
    if (!canNext && !canPrevious) {
        return null;
    }

    return (
        <div className="r4e-pager">
            {label ? <span className="pager-label">{label}</span> : null}{' '}
            <Button
                className="rounded-pill"
                aria-label="previous"
                variant="icon"
                disabled={!canPrevious || disabled}
                onClick={onPrevious}
            >
                <i className="icon-angle-left" />
            </Button>
            <Button
                className="rounded-pill"
                aria-label="next"
                variant="icon"
                disabled={!canNext || disabled}
                onClick={onNext}
            >
                <i className="icon-angle-right" />
            </Button>
        </div>
    );
};
